import { AgendaItemDetailModel } from "models/AgendaItemDetailModel";
import { createContext } from "react";
import { TriggerEvent } from "react-contexify";

interface AgendaItemsContextMenuContextProps {
  showContextMenu: (event: TriggerEvent, item: AgendaItemDetailModel) => void;
}

export const AgendaItemsContextMenuContext = createContext({} as AgendaItemsContextMenuContextProps);
